import { Button, styled } from "@mui/material";

export const FormContainer = styled("div")({
    display: "flex",
    padding: "20px 40px 40px 40px",
    flexDirection: "column",
    alignItems: "center",
});

export const Label = styled("div")({
    fontWeight: 700,
    marginBottom: 15,
    marginTop: 10,
    display: "flex",
});

export const ButtonContainer = styled("div")({
    width: "100%",
    display: "flex",
    justifyContent: "center",
    margin: "20px 0px",
});

export const RadioButtonLabel = styled("div")({
    marginRight: 20,
});

export const RadioFieldContent = styled("div")({
    display: "flex",
});

export const StyledImage = styled("img")`
    display: flex;
    width: 80%;
`;

export const ImageContainer = styled("div")`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const CustomButton = styled(Button)({
    minWidth: 200,
});

export const SecondaryButton = styled(CustomButton)(({ theme }) => ({
    backgroundColor: theme.palette.secondary.dark,
    color: theme.palette.secondary.contrastText,
}));
